export const DASHBOARD_CONFIG = {
  REBALANCING_THRESHOLD: 5, // 5%
  SECTOR_REBALANCING_THRESHOLD: 5, // 5%
  OVERWEIGHT_THRESHOLD: 2, // 2%
  RISK_HIGH_THRESHOLD: 70,
  RISK_MEDIUM_THRESHOLD: 45,
  WEIGHT_OVERWEIGHT_THRESHOLD: 1.2,
  WEIGHT_NEUTRAL_THRESHOLD: 0.9,
  WEIGHT_UNDERWEIGHT_THRESHOLD: 0.7,
  BUDGET_HIGH_THRESHOLD: 20,
  BUDGET_MEDIUM_THRESHOLD: 14,
  BUDGET_LOW_THRESHOLD: 10,
  TRIM_CRITICAL_THRESHOLD: 10,
  TRIM_WARNING_THRESHOLD: 6,
  DEFAULT_RISK_SCORE: 45,
  DEFAULT_MACRO_WEIGHT: 1.0,
  DEFAULT_RISK_BUDGET: 15,
  DEFAULT_TRIM_THRESHOLD: 5,
  ALERT_CRITICAL_THRESHOLD: 85,
  ALERT_HIGH_THRESHOLD: 65,
  ALERT_ELEVATED_THRESHOLD: 45,
  ALERT_WATCH_THRESHOLD: 25,
  IV_RANK_EXTREME_THRESHOLD: 80,
  IV_RANK_HIGH_THRESHOLD: 70,
  IV_RANK_ELEVATED_THRESHOLD: 60,
  PUT_CALL_RATIO_BEARISH_THRESHOLD: 1.2,
  PUT_CALL_RATIO_BULLISH_THRESHOLD: 0.8,
  PUT_CALL_RATIO_NEUTRAL: 1.0,
  SHORT_RATIO_HIGH_THRESHOLD: 10,
  SHORT_RATIO_CRITICAL_THRESHOLD: 15,
  RISK_BASELINE: 50,
};
